export default "__VITE_ASSET__cc8bd65b__"